import React from "react";
import Drawer from "@material-ui/core/Drawer";
import {Grid} from "@material-ui/core";
import Hidden from "@material-ui/core/Hidden";
import {MenuItems} from "./MenuItems";
import Paper from "@material-ui/core/Paper";
import List from "@material-ui/core/List";

export const SideMenu = props => {
    return (
        <>
            <Hidden xsDown>
                <Grid item xs={4} sm={4} md={3} lg={2} >
                    <Paper className="sub-root">
                        <List>
                        <MenuItems/>
                        </List>
                    </Paper>
                </Grid>
            </Hidden>

            <Hidden smUp>
                <Drawer
                    variant="temporary"
                    open={props.open}
                    anchor="left"
                    onBackdropClick={props.handleToggleDrawer}
                >
                    <List onClick={props.handleToggleDrawer}
                          style={{width:'240px'}}
                          className='overflow-x-hidden'
                    >
                    <MenuItems/>
                    </List>
                </Drawer>
            </Hidden>
        </>
    );
}
